export default __webpack_public_path__ + "static/media/background-cover-image.b892fbf9.jpg";